import React, { useEffect, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { ApexOptions } from "apexcharts";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import isoWeek from 'dayjs/plugin/isoWeek';
import { API_URL } from '../../../environment';
dayjs.extend(utc)

interface ContatoSDR {
  fone: string;
  nome: string;
  created_at: string;
  mensagens: number | string;
  resposta_button?: string | null;
  ultima_mensagem?: string; // <-- novo campo
  data_ultima_mensagem?: string; // <-- novo campo
}



interface MensagemSDR {
  id: number;
  status: string;
  mensagem: string;
  timestamp: string;
  type?: string; // Added type for media handling
}



const LeadsDashboard = () => {
  const [totalLeads, setTotalLeads] = useState<number>(0);
  const [leadsPorFunil, setLeadsPorFunil] = useState<any[]>([]);
  const [leadsPorFunilHistorico, setLeadsPorFunilHistorico] = useState<any[]>([]);
  const [leadsPorData, setLeadsPorData] = useState<any[]>([]);
  const [filtroTempo, setFiltroTempo] = useState<'dia' | 'semana' | 'mes'>('mes');
  const [mensagensSemResposta, setMensagensSemResposta] = useState<any[]>([]);
  const [funilSelecionado, setFunilSelecionado] = useState<string>('');
  const [etapaFiltrada, setEtapaFiltrada] = useState<string | null>(null);
  const [mensagensDetalhadas, setMensagensDetalhadas] = useState<any[]>([]);
  const [totalConversas, setTotalConversas] = useState(0);
  const [totalMensagens, setTotalMensagens] = useState(0);
  const [temposPorEtapa, setTemposPorEtapa] = useState<any[]>([]);
  const [mostrarSDR, setMostrarSDR] = useState(false);
  const [dadosSDR, setDadosSDR] = useState<any[]>([]);
  const [temSDR, setTemSDR] = useState(false);
  const [clienteSDR, setClienteSDR] = useState('');
  const [loadingSDR, setLoadingSDR] = useState(false);
  const [contatosSDR, setContatosSDR] = useState<ContatoSDR[]>([]);
  const [mensagensSDR, setMensagensSDR] = useState<MensagemSDR[]>([]);
  const [allMessagesSDR, setAllMessagesSDR] = useState<Record<string, MensagemSDR[]>>({});
  const [contatoSelecionadoSDR, setContatoSelecionadoSDR] = useState<ContatoSDR | null>(null);
  const [mostrarTodosContatos, setMostrarTodosContatos] = useState(false);
  const [filtroResposta, setFiltroResposta] = useState<'Sim' | 'Não' | 'Bloq' | 'Todos'>('Sim');
  const [clientesSDR, setClientesSDR] = useState<string[]>([]);
  const [clienteSelecionadoSDR, setClienteSelecionadoSDR] = useState<string | null>(null);
  // Mapas globais: todos os SDRs carregados de uma vez
  const [allContatosBySDR, setAllContatosBySDR] = useState<Record<string, ContatoSDR[]>>({});
  const [allMessagesBySDR, setAllMessagesBySDR] = useState<Record<string, Record<string, MensagemSDR[]>>>({});
  const [allDadosBySDR, setAllDadosBySDR] = useState<Record<string, any[]>>({});
  const [searchTermSDR, setSearchTermSDR] = useState(''); // <-- novo estado de busca
  const [funilExpandido, setFunilExpandido] = useState<string | null>(null);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [lookerKey, setLookerKey] = useState(0); // <-- key to force re-render













  




  const agruparPorFiltro = () => {
    const mapaAcumulado: Record<string, Set<string>> = {};

    // Ordenar os dados por data
    const dadosOrdenados = [...leadsPorData].sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());

    dadosOrdenados.forEach(item => {
      const date = dayjs(item.created_at);
      let chave = '';

      if (filtroTempo === 'dia') {
        chave = date.format('YYYY-MM-DD');
      } else if (filtroTempo === 'semana') {
        chave = `Semana ${date.isoWeek()} - ${date.year()}`;
      } else if (filtroTempo === 'mes') {
        chave = date.format('YYYY-MM');
      }

      if (!mapaAcumulado[chave]) {
        mapaAcumulado[chave] = new Set();
      }

      for (const fone of item.fones || []) {
        mapaAcumulado[chave].add(fone);
      }
    });

    // Agora acumula os valores até cada data
    const datasOrdenadas = Object.keys(mapaAcumulado).sort((a, b) => {
      const d1 = filtroTempo === 'semana'
        ? parseInt(a.split(' ')[1])
        : new Date(a).getTime();
      const d2 = filtroTempo === 'semana'
        ? parseInt(b.split(' ')[1])
        : new Date(b).getTime();
      return d1 - d2;
    });

    const acumulador = new Set<string>();
    const resultado: { label: string; total: number }[] = [];

    for (const chave of datasOrdenadas) {
      mapaAcumulado[chave].forEach(fone => {
        acumulador.add(fone);
      });
      resultado.push({ label: chave, total: acumulador.size });
    }

    return resultado;
  };

  const agruparMensagensSemResposta = () => {
    const agrupado: Record<string, number> = {};

    mensagensSemResposta.forEach(item => {
      const date = dayjs.utc(item.data).local();
      let chave = '';

      if (filtroTempo === 'dia') {
        chave = date.format('YYYY-MM-DD');
      } else if (filtroTempo === 'semana') {
        chave = `Semana ${date.isoWeek()} - ${date.year()}`;
      } else if (filtroTempo === 'mes') {
        chave = date.format('YYYY-MM');
      }

      if (!agrupado[chave]) agrupado[chave] = 0;
      agrupado[chave] += item.total_sem_resposta || 0;
    });

    return Object.entries(agrupado).map(([label, total]) => ({
      label,
      total
    }));
  };
  


  // Carrega contatos, mensagens e dados de TODOS os SDRs em paralelo
  const fetchAllSDRs = (clientes: string[], id_time: string) => {
    fetch(`${API_URL}/admin/sdr_clientes`)
      .then(r => r.json())
      .then((sdrList: any[]) => {
        const dadosMap: Record<string, any[]> = {};
        const promises = clientes.map(cliente => {
          const sdr = sdrList.find(c => c.cliente === cliente);
          if (sdr?.id_sdr) {
            return fetch(`${API_URL}/admin/dashboard_sdr?id_sdr=${sdr.id_sdr}`)
              .then(r => r.json())
              .then(d => { dadosMap[cliente] = d; });
          }
          return Promise.resolve();
        });
        Promise.all(promises).then(() => setAllDadosBySDR(dadosMap));
      })
      .catch(console.error);

    const contatosMap: Record<string, ContatoSDR[]> = {};
    const msgsMap: Record<string, Record<string, MensagemSDR[]>> = {};

    const contactPromises = clientes.map(cliente =>
      fetch(`${API_URL}/admin/contacts?cliente=${encodeURIComponent(cliente)}&id_time=${id_time}`)
        .then(res => res.json())
        .then(data => { contatosMap[cliente] = data || []; })
        .catch(console.error)
    );

    const msgPromises = clientes.map(cliente =>
      fetch(`${API_URL}/admin/messages_all?cliente=${encodeURIComponent(cliente)}`)
        .then(res => res.json())
        .then(data => { msgsMap[cliente] = data || {}; })
        .catch(console.error)
    );

    Promise.all([...contactPromises, ...msgPromises]).then(() => {
      setAllContatosBySDR(contatosMap);
      setAllMessagesBySDR(msgsMap);
    });
  };

  // Deriva contatos/mensagens/dados do SDR selecionado a partir dos mapas globais
  useEffect(() => {
    if (!clienteSelecionadoSDR) return;
    setContatosSDR(allContatosBySDR[clienteSelecionadoSDR] || []);
    setAllMessagesSDR(allMessagesBySDR[clienteSelecionadoSDR] || {});
    setDadosSDR(allDadosBySDR[clienteSelecionadoSDR] || []);
  }, [clienteSelecionadoSDR, allContatosBySDR, allMessagesBySDR, allDadosBySDR]);

  useEffect(() => {
    const id_cliente = localStorage.getItem("id_cliente");
    if (!id_cliente) return;

    // Total de Leads
    fetch(`${API_URL}/dashboard/total_leads?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => {
        setTotalLeads(data.total_atual || 0);
        setLeadsPorData(data.por_data || []);
      })
      .catch(console.error);

    // Leads por Funil e Etapa
    fetch(`${API_URL}/dashboard/por_funil_etapa?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => {
        setLeadsPorFunil(data);
        if (data && data.length > 0) {
          setFunilSelecionado(data[0].funil);  // 🔹 pré-seleciona o primeiro funil
        }
      })
      .catch(console.error);
    
    // Leads por Funil e Etapa (Histórico) — usado apenas no gráfico
    fetch(`${API_URL}/dashboard/por_funil_etapa_historico?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => {
        setLeadsPorFunilHistorico(data || []);
      })
      .catch(console.error);

    // Mensagens sem resposta por data
    fetch(`${API_URL}/dashboard/mensagens_sem_resposta?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => {
        console.log("mensagensSemResposta:", data); // <-- aqui
        setMensagensSemResposta(data || []);  
      })
      .catch(console.error);

    fetch(`${API_URL}/dashboard/mensagens_sem_resposta_detalhado?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => setMensagensDetalhadas(data || []))
      .catch(console.error);

    fetch(`${API_URL}/dashboard/totais_conversas_mensagens?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => {
        setTotalConversas(data.total_conversas || 0);
        setTotalMensagens(data.total_mensagens || 0);
      })
      .catch(console.error);

    fetch(`${API_URL}/dashboard/tempo_medio_etapa?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => setTemposPorEtapa(data || []))
      .catch(console.error);

    // Verifica se existe SDR e carrega TODOS os SDRs de uma vez
    fetch(`${API_URL}/dashboard/tem_sdr?id_time=${id_cliente}`)
      .then(res => res.json())
      .then(data => {
        if (data.tem_sdr && Array.isArray(data.clientes)) {
          setTemSDR(true);
          setClientesSDR(data.clientes);
          setClienteSelecionadoSDR(data.clientes[0]);
          fetchAllSDRs(data.clientes, id_cliente!);
        }
      });
    

  }, []);

  // Quando selecionar contato, lê mensagens do mapa (instantâneo)
  useEffect(() => {
    if (!contatoSelecionadoSDR) {
      setMensagensSDR([]);
      return;
    }
    setMensagensSDR(allMessagesSDR[contatoSelecionadoSDR.fone] || []);
  }, [contatoSelecionadoSDR, allMessagesSDR]);


  

  const generateSeries = () => {
    const etapasSet = new Set<string>();
    leadsPorFunil.forEach(f => f.etapas.forEach((e: any) => etapasSet.add(e.nome)));
    const etapas = Array.from(etapasSet);

    return etapas.map(nomeEtapa => {
      return {
        name: nomeEtapa,
        data: leadsPorFunil.map(funil => {
          const etapa = funil.etapas.find((e: any) => e.nome === nomeEtapa);
          return etapa ? etapa.total : 0;
        })
      };
    });
  };

  const generateSeriesEtapas = () => {
    const funil = leadsPorFunilHistorico.find(f => f.funil === funilSelecionado);
    if (!funil) return [];

    const hoje = dayjs();
    const ultimos30 = Array.from({ length: 30 }, (_, i) =>
      hoje.subtract(29 - i, 'day').format('YYYY-MM-DD')
    );

    const todasDatas = new Set<string>();

    funil.etapas.forEach((etapa: any) => {
      etapa.historico.forEach((item: any) => {
        const data = dayjs(item.data);
        const chave = modoVisualizacao === 'mensal'
          ? data.format('YYYY-MM')
          : data.format('YYYY-MM-DD');
        todasDatas.add(chave);
      });
    });

    const datasOrdenadas = Array.from(todasDatas)
      .filter(d => modoVisualizacao === 'mensal' || ultimos30.includes(d))
      .sort();

    return funil.etapas
      .filter((etapa: any) => !etapaFiltrada || etapa.nome === etapaFiltrada)
      .map((etapa: any) => {
        const agrupado: Record<string, number> = {};
        etapa.historico.forEach((item: any) => {
          const data = dayjs(item.data);
          const chave = modoVisualizacao === 'mensal'
            ? data.format('YYYY-MM')
            : data.format('YYYY-MM-DD');
          if (!agrupado[chave]) agrupado[chave] = 0;
          agrupado[chave] += item.total || 0;
        });

        return {
          name: etapa.nome,
          data: datasOrdenadas.map(d => agrupado[d] || 0)
        };
      });
  };

  const generateCategoriesEtapas = () => {
    const funil = leadsPorFunilHistorico.find(f => f.funil === funilSelecionado);
    if (!funil) return [];

    const hoje = dayjs();
    const ultimos30 = Array.from({ length: 30 }, (_, i) =>
      hoje.subtract(29 - i, 'day').format('YYYY-MM-DD')
    );

    const datas = new Set<string>();
    funil.etapas.forEach((etapa: any) => {
      etapa.historico.forEach((item: any) => {
        const data = dayjs(item.data);
        const chave = modoVisualizacao === 'mensal'
          ? data.format('YYYY-MM')
          : data.format('YYYY-MM-DD');
        datas.add(chave);
      });
    });

    return Array.from(datas)
      .filter(d => modoVisualizacao === 'mensal' || ultimos30.includes(d))
      .sort();
  };


  const calcularLeadsPorFunil = () => {
    return leadsPorFunil.map((f: any) => {
      const total = f.etapas.reduce((sum: number, e: any) => sum + (e.total || 0), 0);
      return {
        nome: f.funil,
        total
      };
    });
  };


  const dadosAgrupados = agruparPorFiltro();

  const dataLabels = dadosAgrupados.map(d => d.label);
  const dataSeries = dadosAgrupados.map(d => d.total);

  const dadosMensagensSemResposta = agruparMensagensSemResposta();
  const dataLabelsMSR = dadosMensagensSemResposta.map(d => d.label);
  const dataSeriesMSR = dadosMensagensSemResposta.map(d => d.total);
  const ultimos30dias = Array.from({ length: 30 }, (_, i) =>
    dayjs().subtract(29 - i, 'day').format('YYYY-MM-DD')
  );
  const [modoVisualizacao, setModoVisualizacao] = useState<'diario' | 'mensal'>('diario');




  const leadsChartOptions: ApexOptions = {
    chart: { type: 'line' },
    xaxis: {
      categories: dataLabels,
      labels: { rotate: -45 }
    },
    yaxis: {
      labels: {
        style: { fontSize: '12px' }
      }
    },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth' }
  };

  

  const mensagensChartOptions: ApexOptions = {
    chart: { type: 'bar' },
    xaxis: {
      categories: dataLabelsMSR,
      labels: { rotate: -45 }
    },
    yaxis: {
      labels: {
        style: { fontSize: '12px' }
      }
    },
    dataLabels: { enabled: false },
    colors: ['#E11D48'],
  };

  const cores = [
    "bg-primary",        // azul
    "bg-success",        // verde
    "bg-warning",        // amarelo
    "bg-danger",         // vermelho
    "bg-info",           // azul claro
    "bg-secondary",      // cinza
  ];




  const funilOptions: ApexOptions = {
    chart: {
      type: 'bar' as const,
      stacked: true,
      toolbar: { show: false },
    },
    xaxis: {
      categories: leadsPorFunil.map(f => f.funil),
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '13px',
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: '#6B7280',
          fontSize: '13px',
        }
      }
    },
    legend: { show: true },
    colors: ['#FF6F28', '#6366F1', '#22C55E', '#E11D48', '#0C4B5E', '#EAB308'],
  };

  // Polling: atualiza TODOS os SDRs periodicamente
  useEffect(() => {
    const id_cliente = localStorage.getItem("id_cliente");
    if (!temSDR || clientesSDR.length === 0) return;

    const interval = setInterval(() => {
      fetchAllSDRs(clientesSDR, id_cliente!);
    }, 5000);

    return () => clearInterval(interval);
  }, [temSDR, clientesSDR]);

  useEffect(() => {
    if (clientesSDR.length > 0) {
      setClienteSelecionadoSDR(prev =>
        prev && clientesSDR.includes(prev) ? prev : clientesSDR[0]
      );
    }
  }, [clientesSDR]);








  return (
    <div className="page-wrapper">
      <style>{`
        .ld-content {
          overflow-x: hidden !important;
          max-width: 100vw;
        }
        .ld-stats-row {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 1.5rem;
          width: 100%;
        }
        .ld-stat-hero-wrap {
          flex: 0 0 280px;
        }
        .ld-stats-funis {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          flex: 1;
          min-width: 0;
        }
        .ld-stat-funil-wrap {
          flex: 1 1 200px;
          max-width: 280px;
          min-width: 0;
        }
        @media (max-width: 992px) {
          .ld-content {
            padding: 10px 12px 0 !important;
          }
          .ld-stats-row {
            flex-direction: column;
            gap: 0.75rem;
          }
          .ld-stat-hero-wrap {
            flex: 1 1 100% !important;
            max-width: 100% !important;
          }
          .ld-stats-funis {
            gap: 0.75rem;
          }
          .ld-stat-funil-wrap {
            flex: 1 1 calc(50% - 0.375rem) !important;
            max-width: 100% !important;
          }
          .ld-chart-card .card-header {
            flex-wrap: wrap !important;
            gap: 8px;
          }
          .ld-chart-card .card-header .form-select {
            width: 100% !important;
          }
          .ld-chart-card .card-body {
            padding: 12px 8px;
          }
          .ld-table-card .card-body {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
          .ld-sdr-section .ld-sdr-selector {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
          .ld-sdr-section .ld-sdr-selector .form-select {
            width: 100% !important;
          }
        }
        @media (max-width: 480px) {
          .ld-stat-funil-wrap {
            flex: 1 1 100% !important;
          }
        }
      `}</style>
      <div className="content ld-content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Dashboard de Leads</h2>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="ms-2 head-icons">
              <CollapseHeader />
            </div>
          </div>
        </div>

        <div className="row">

          <div className="row mt-4">
            {temSDR && (
              <div className="row mt-4 ld-sdr-section">
                <div className="d-flex align-items-center gap-3 mb-3 ld-sdr-selector">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, var(--brand-primary, #007e94), #00a5c0)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ti ti-headset" style={{ color: '#fff', fontSize: 18 }} />
                    </div>
                    <label className="fw-bold mb-0" style={{ color: '#1a1a2e', fontSize: 15 }}>SDR:</label>
                  </div>
                  <select
                    className="form-select w-auto"
                    value={clienteSelecionadoSDR || ''}
                    onChange={(e) => {
                      setClienteSelecionadoSDR(e.target.value);
                      setContatoSelecionadoSDR(null);
                      setMensagensSDR([]);
                    }}
                  >
                    {clientesSDR.map((cliente, idx) => (
                      <option key={idx} value={cliente}>{cliente}</option>
                    ))}
                  </select>
                </div>
                <div className="col-12">
                  <div className="card ld-chart-card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0" style={{ fontSize: '15px', fontWeight: 700, color: '#1a1a2e' }}>
                        <i className="ti ti-chart-bar me-2" style={{ color: 'var(--brand-primary, #007e94)' }} />
                        Interações do SDR — {clienteSelecionadoSDR}
                      </h5>
                      <span className="badge" style={{ background: 'rgba(var(--brand-primary-rgb, 0, 126, 148),0.08)', color: 'var(--brand-primary, #007e94)', fontSize: '12px', fontWeight: 600 }}>
                        {dadosSDR.length} {dadosSDR.length === 1 ? 'registro' : 'registros'}
                      </span>
                    </div>
                    <div className="card-body p-0">
                      {loadingSDR ? (
                        <div className="text-center py-5">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                          </div>
                        </div>
                      ) : dadosSDR.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="ti ti-inbox-off" style={{ fontSize: '32px', opacity: 0.4 }} />
                          <p className="mt-2 mb-0">Nenhuma interação encontrada</p>
                        </div>
                      ) : (
                        <div className="table-responsive ld-sdr-table">
                          <table className="table mb-0">
                            <thead>
                              <tr>
                                <th>Data</th>
                                <th>Disparos</th>
                                <th>1ª</th>
                                <th>2ª</th>
                                <th>3ª</th>
                                <th>4ª</th>
                                <th>5ª</th>
                                <th>6ª</th>
                                <th>7ª</th>
                                <th style={{ color: '#22c55e' }}>Sim</th>
                                <th style={{ color: '#ef4444' }}>Não</th>
                                <th style={{ color: '#6366f1' }}>Email</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dadosSDR.map((linha, idx) => (
                                <tr key={idx}>
                                  <td style={{ fontWeight: 600 }}>{linha.data}</td>
                                  <td><strong>{linha.disparos}</strong></td>
                                  {linha.interacoes.map((qtd: number, i: number) => {
                                    const pct = linha.disparos > 0 ? ((qtd / linha.disparos) * 100).toFixed(1) : '0.0';
                                    return (
                                      <td key={i}>
                                        {qtd} <span className="text-muted">({pct}%)</span>
                                      </td>
                                    );
                                  })}
                                  {["sim", "nao", "email"].map((campo) => {
                                    const qtd = linha[campo] || 0;
                                    const pct = linha.disparos > 0 ? ((qtd / linha.disparos) * 100).toFixed(1) : '0.0';
                                    const color = campo === 'sim' ? '#22c55e' : campo === 'nao' ? '#ef4444' : '#6366f1';
                                    return (
                                      <td key={campo}>
                                        <span style={{ color, fontWeight: 600 }}>{qtd}</span>{' '}
                                        <span className="text-muted">({pct}%)</span>
                                      </td>
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {temSDR && (
              <div className="row mt-4 ld-sdr-section">
                <div className="col-12 col-xl-4 ld-sdr-contacts">
                  <div className="card ld-chart-card">
                    <div className="card-header" style={{ padding: '16px 20px' }}>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0" style={{ fontSize: '15px', fontWeight: 700, color: '#1a1a2e' }}>
                          <i className="ti ti-address-book me-2" style={{ color: 'var(--brand-primary, #007e94)' }} />
                          Contatos do SDR
                        </h5>
                        <span className="badge" style={{ background: 'rgba(var(--brand-primary-rgb, 0, 126, 148),0.08)', color: 'var(--brand-primary, #007e94)', fontSize: '11px', fontWeight: 600 }}>
                          {contatosSDR.filter(c => {
                            const fp = filtroResposta === 'Todos' || c.resposta_button === filtroResposta;
                            const pm = filtroResposta !== 'Todos' ? Number(c.mensagens) > 0 : true;
                            const ms = String(c.nome || '').toLowerCase().includes(searchTermSDR.toLowerCase()) || String(c.fone || '').includes(searchTermSDR);
                            return fp && pm && ms;
                          }).length} contatos
                        </span>
                      </div>
                      <div className="d-flex gap-2">
                        <div className="input-group input-group-sm" style={{ flex: 1 }}>
                          <span className="input-group-text" style={{ background: 'transparent', border: '1.5px solid rgba(0,0,0,0.08)', borderRight: 'none', borderRadius: '8px 0 0 8px' }}>
                            <i className="ti ti-search" style={{ fontSize: 14, color: '#8a94a6' }} />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar contato..."
                            value={searchTermSDR}
                            onChange={(e) => setSearchTermSDR(e.target.value)}
                            style={{ border: '1.5px solid rgba(0,0,0,0.08)', borderLeft: 'none', borderRadius: '0 8px 8px 0', fontSize: 13 }}
                          />
                        </div>
                        <select
                          className="form-select form-select-sm"
                          value={filtroResposta}
                          onChange={(e) => setFiltroResposta(e.target.value as any)}
                          style={{ width: 'auto', borderRadius: 8, border: '1.5px solid rgba(0,0,0,0.08)', fontSize: 13 }}
                        >
                          <option value="Sim">Sim</option>
                          <option value="Não">Não</option>
                          <option value="Bloq">Bloq</option>
                          <option value="Todos">Todos</option>
                        </select>
                      </div>
                    </div>
                    <div className="card-body p-0" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                      {contatosSDR
                        .filter(contato => {
                          const filtroPadrao = filtroResposta === 'Todos' || contato.resposta_button === filtroResposta;
                          const precisaMensagem = filtroResposta !== 'Todos' ? Number(contato.mensagens) > 0 : true;
                          const matchesSearch =
                            String(contato.nome || '').toLowerCase().includes(searchTermSDR.toLowerCase()) ||
                            String(contato.fone || '').includes(searchTermSDR);
                          return filtroPadrao && precisaMensagem && matchesSearch;
                        })
                        .map((contato, index) => {
                          const isActive = contatoSelecionadoSDR?.fone === contato.fone;
                          const hasName = !!contato.nome;
                          const respostaCor = contato.resposta_button === 'Sim' ? '#22c55e' : contato.resposta_button === 'Não' ? '#ef4444' : contato.resposta_button === 'Bloq' ? '#f59e0b' : '#8a94a6';

                          return (
                            <div
                              key={index}
                              className={`ld-sdr-contact-item ${isActive ? 'active' : ''} ${hasName ? 'has-name' : ''}`}
                              onClick={() => {
                                setContatoSelecionadoSDR(contato);
                              }}
                            >
                              <div className="d-flex align-items-center gap-3">
                                {/* Avatar */}
                                <div className="ld-contact-avatar" style={{
                                  width: 40, height: 40, borderRadius: 12, flexShrink: 0,
                                  background: isActive ? 'rgba(255,255,255,0.15)' : hasName ? 'rgba(var(--brand-primary-rgb, 0, 126, 148),0.08)' : 'rgba(0,0,0,0.04)',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  fontSize: 16, fontWeight: 700,
                                  color: isActive ? '#fff' : hasName ? 'var(--brand-primary, #007e94)' : '#8a94a6'
                                }}>
                                  {hasName ? contato.nome!.charAt(0).toUpperCase() : <i className="ti ti-user" style={{ fontSize: 18 }} />}
                                </div>
                                {/* Info */}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="ld-contact-name text-truncate" style={{ maxWidth: '60%' }}>
                                      {contato.nome || '(sem nome)'}
                                    </span>
                                    {contato.data_ultima_mensagem && (
                                      <span className="ld-contact-time">
                                        {dayjs(contato.data_ultima_mensagem).format('DD/MM HH:mm')}
                                      </span>
                                    )}
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mt-1">
                                    <span className="ld-contact-phone">{contato.fone}</span>
                                    <span style={{
                                      fontSize: 10, fontWeight: 700,
                                      padding: '1px 6px', borderRadius: 4,
                                      background: `${respostaCor}15`, color: respostaCor
                                    }}>
                                      {contato.resposta_button || '—'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>

                <div className="col-12 col-xl-8 ld-sdr-messages mt-3 mt-xl-0">
                  <div className="card ld-chart-card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-3">
                        {contatoSelecionadoSDR && (
                          <div style={{
                            width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                            background: 'rgba(var(--brand-primary-rgb, 0, 126, 148),0.08)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 14, fontWeight: 700, color: 'var(--brand-primary, #007e94)'
                          }}>
                            {contatoSelecionadoSDR.nome ? contatoSelecionadoSDR.nome.charAt(0).toUpperCase() : <i className="ti ti-user" />}
                          </div>
                        )}
                        <div>
                          <h5 style={{ fontSize: '15px', fontWeight: 700, color: '#1a1a2e', margin: 0 }}>
                            {contatoSelecionadoSDR?.nome || 'Mensagens'}
                          </h5>
                          {contatoSelecionadoSDR && (
                            <span style={{ fontSize: 12, color: '#8a94a6' }}>{contatoSelecionadoSDR.fone}</span>
                          )}
                        </div>
                      </div>
                      {mensagensSDR.length > 0 && (
                        <span className="badge" style={{ background: 'rgba(var(--brand-primary-rgb, 0, 126, 148),0.08)', color: 'var(--brand-primary, #007e94)', fontSize: '12px', fontWeight: 600 }}>
                          {mensagensSDR.length} msg
                        </span>
                      )}
                    </div>
                    <div className="ld-chat-body" style={{ maxHeight: '600px', overflowY: 'auto', padding: '20px' }}>
                      {mensagensSDR.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="ti ti-message-dots" style={{ fontSize: '48px', opacity: 0.3 }} />
                          <p className="mt-3 mb-1" style={{ fontSize: 15, fontWeight: 600 }}>Nenhuma mensagem selecionada</p>
                          <p className="mb-0" style={{ fontSize: 13 }}>Selecione um contato ao lado para ver o histórico</p>
                        </div>
                      ) : (
                        mensagensSDR.map((msg, idx) => {
                          const isReceived = String(msg.status).toLowerCase() === 'received';
                          const alinhamento = isReceived ? 'justify-content-start' : 'justify-content-end';

                          return (
                            <div
                              key={idx}
                              className={`d-flex mb-3 ${alinhamento}`}
                            >
                              <div className={`ld-msg-bubble ${isReceived ? 'received' : 'sent'}`}>
                                <div className="ld-msg-content">
                                {(() => {
                                        const isPublicUrl = /^(https?:\/\/|blob:|\/storage\/v1\/object\/public\/)/i.test(msg.mensagem);
                                        const msgLower = msg.mensagem?.toLowerCase?.() || "";

                                        let type = msg.type;

                                        // Detecta tipo pela pasta do bucket Supabase (/arquivos/{tipo}/...)
                                        const bucketMatch = msgLower.match(/\/arquivos\/(image|imagem|video|audio|document|documento)\//);
                                        if (bucketMatch) {
                                          const bucketType = bucketMatch[1];
                                          if (bucketType === "image" || bucketType === "imagem") type = "image";
                                          else if (bucketType === "video") type = "video";
                                          else if (bucketType === "audio") type = "audio";
                                          else if (bucketType === "document" || bucketType === "documento") type = "document";
                                        }
                                        // Fallback: detecta por extensão de arquivo
                                        else if (msgLower.match(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/)) type = "image";
                                        else if (msgLower.match(/\.(mp4|mov|avi|webm)(\?.*)?$/)) type = "video";
                                        else if (msgLower.match(/\.(pdf|doc|docx|xls|xlsx|ppt|pptx)(\?.*)?$/)) type = "document";
                                        else if (msgLower.match(/\.(mp3|wav|ogg|m4a|opus|oga)(\?.*)?$/)) type = "audio";
                                        // Fallback: URL do Supabase storage sem pasta tipada = trata como link genérico
                                        else if (!type || type === "conversation") {
                                          if (/supabase\.co\/storage\/v1\/object\//i.test(msg.mensagem)) type = "document";
                                        }

                                        switch (type) {
                                          case "conversation": {
                                            return <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{msg.mensagem}</span>;
                                          }

                                          case "imagem":
                                          case "image": {
                                            const src = isPublicUrl
                                              ? msg.mensagem
                                              : `data:image/png;base64,${msg.mensagem}`;
                                            return (
                                              <img
                                                src={src}
                                                alt="Imagem enviada"
                                                style={{ maxWidth: "100%", borderRadius: 8, cursor: "pointer" }}
                                                onClick={() => window.open(src, "_blank")}
                                              />
                                            );
                                          }

                                          case "video": {
                                            const src = isPublicUrl
                                              ? msg.mensagem
                                              : `data:video/mp4;base64,${msg.mensagem}`;
                                            return (
                                              <video
                                                controls
                                                src={src}
                                                style={{ maxWidth: "100%", borderRadius: 8 }}
                                              />
                                            );
                                          }

                                          case "document": {
                                            const href = isPublicUrl
                                              ? msg.mensagem
                                              : `data:application/octet-stream;base64,${msg.mensagem}`;
                                            const fileName =
                                              (msg.mensagem.split("/").pop() || "documento").replace(/\?.*$/, "");
                                            return (
                                              <a
                                                href={href}
                                                download={fileName}
                                                rel="noreferrer"
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  textDecoration: "none",
                                                  color: "#007bff",
                                                  fontWeight: "bold"
                                                }}
                                              >
                                                <i className="ti ti-file-text" style={{ fontSize: 20 }} />
                                                {fileName}
                                              </a>
                                            );
                                          }

                                          case "audio": {
                                            const src = isPublicUrl
                                              ? msg.mensagem
                                              : `data:audio/mp3;base64,${msg.mensagem}`;
                                            return (
                                              <div style={{ width: "100%", minWidth: "250px" }}>
                                                <audio controls src={src} style={{ width: "100%" }} />
                                              </div>
                                            );
                                          }

                                          default:
                                            return <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{msg.mensagem}</span>;
                                        }
                                      })()}
                                </div>
                                <div className="ld-msg-time">
                                  {new Date(msg.timestamp).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(localStorage.getItem("id_cliente") === "175" || localStorage.getItem("id_cliente") === "144") && (
              <div className="row mt-4">
                <div className="col-12">
                  <div className="ld-chart-card card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5>Relatório TNP</h5>
                      <button 
                        className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                        onClick={() => setLookerKey(prev => prev + 1)}
                      >
                        <i className="ti ti-refresh" />
                        Atualizar Dados
                      </button>
                    </div>
                    <div className="card-body">
                      <iframe 
                        key={lookerKey}
                        width="100%" 
                        height="800" 
                        src="https://lookerstudio.google.com/embed/reporting/276317e0-2ad6-4054-8431-b88bb25f0d99/page/p_orgzvgwwsd" 
                        frameBorder="0" 
                        style={{ border: 0 }} 
                        allowFullScreen 
                        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="footer ld-footer d-sm-flex align-items-center justify-content-between bg-white">
        <p className="mb-0">2025 ©</p>
      </div>
    </div>
  );
};

export default LeadsDashboard;